import React, { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const Button = memo(
  ({ onClick, variant = 'primary', children, disabled }) => {
    const componentCls = classNames(
      'text-sm px-6 py-2 select-none rounded w-auto transition-all duration-300',
      {
        'bg-slate-300 text-slate-500': disabled,
        'bg-red-600 hover:bg-red-700 text-white': !disabled && variant === 'primary',
        'bg-slate-400 text-white hover:bg-slate-500': !disabled && variant === 'secondary',
      }
    );
    return (
      <button type='button' className={componentCls} onClick={onClick} disabled={disabled}>
        {children}
      </button>
    );
  }
);

Button.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
}
